import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';
import { TenantReadinessSummary } from '@savgroup-front-common/types/TenantOnboarding';

import { buildUrl, prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

export interface GetTenantReadinessQueryArgs {
  sellerId: string;
}

export const getTenantReadinessRequest = ({
  sellerId,
}: GetTenantReadinessQueryArgs): ApiRequestDescriptor => ({
  url: buildUrl(
    `${APIConfiguration.seller}sellers/${sellerId}/onboarding/readiness`,
  ),
  config: { method: SUPPORTED_METHODS.GET },
});

export async function getTenantReadinessQuery({
  sellerId,
}: GetTenantReadinessQueryArgs): Promise<
  BackResponseFailure | BackResponse<TenantReadinessSummary>
> {
  try {
    return await executeQuery<BackResponse<TenantReadinessSummary>>(
      getTenantReadinessRequest({ sellerId }),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}
